import type { Dictionary } from "./translations";

export const ar: Dictionary = {
  "meta.title": "AgentBuck - مقارنة أسعار نماذج الذكاء الاصطناعي",
  "meta.description": "قارن أسعار واجهات API لأبرز نماذج الذكاء الاصطناعي وقدّر التكاليف الشهرية بناءً على استخدامك الفعلي للرموز.",
  "nav.prices": "أسعار النماذج",
  "nav.calculator": "حاسبة التكلفة",
  "nav.providers": "المزوّدون",
  "nav.guide": "دليل الأسعار",
  "nav.method": "المنهجية",
  "aria.home": "الصفحة الرئيسية لـ AgentBuck",
  "aria.language": "اختر اللغة",
  "aria.navigation": "التنقل الرئيسي",
  "aria.breadcrumb": "مسار التنقل",
  "aria.dark": "التبديل إلى الوضع الداكن",
  "aria.light": "التبديل إلى الوضع الفاتح",
  "title.dark": "الوضع الداكن",
  "title.light": "الوضع الفاتح",
  "hero.eyebrow": "قاعدة بيانات أسعار واجهات API للذكاء الاصطناعي",
  "hero.title": "اعثر على نموذج الذكاء الاصطناعي المناسب لميزانيتك",
  "hero.subtitle": "قارن أسعار الإدخال والإخراج والتخزين المؤقت على أساس موحّد، ثم قدّر التكلفة الشهرية باستخدام استهلاكك الفعلي للرموز.",
  "stats.models": "نماذج قابلة للمقارنة",
  "stats.providers": "أبرز المزوّدين",
  "stats.updated": "تحديث البيانات",
  "common.loading": "جارٍ التحميل",
  "notice.snapshot": "البيانات المباشرة غير متاحة. يتم عرض النسخة المحلية المؤرخة في 7 سبتمبر 2026.",
  "common.retry": "إعادة المحاولة",
  "common.home": "الرئيسية",
  "common.models": "النماذج",
  "common.providers": "المزوّدون",
  "common.from": "ابتداءً من",
  "common.viewAll": "عرض الكل",
  "common.backPricing": "العودة إلى الأسعار",
  "share.quick": "مشاركة هذه الصفحة",
  "share.kicker": "شارك مع فريقك",
  "share.title": "مشاركة هذه المقارنة",
  "share.description": "أرسل هذه الصفحة مع النماذج وافتراضات الاستخدام المحددة نفسها.",
  "share.copy": "نسخ الرابط",
  "share.copied": "تم نسخ الرابط",
  "share.more": "مشاركة",
  "share.openComparison": "فتح صفحة المشاركة",
  "share.email": "البريد الإلكتروني",
  "calculator.title": "حاسبة التكلفة الشهرية",
  "calculator.input": "الإدخال الشهري",
  "calculator.output": "الإخراج الشهري",
  "calculator.cache": "نسبة الإدخال المخزّن مؤقتًا",
  "calculator.million": "مليون رمز",
  "calculator.cheapest": "النماذج الخمسة الأقل تكلفة حاليًا",
  "calculator.perMonth": "التقدير / شهر",
  "prices.title": "أسعار النماذج",
  "prices.subtitle": "واجهة API قياسية في الوقت الفعلي، بالدولار الأمريكي لكل مليون رمز",
  "filter.open": "عوامل التصفية",
  "filter.search": "ابحث عن نماذج أو مزوّدين",
  "filter.clearSearch": "مسح البحث",
  "filter.provider": "تصفية حسب المزوّد",
  "filter.allProviders": "جميع المزوّدين",
  "filter.sort": "ترتيب النماذج",
  "filter.favorite": "المحفوظة",
  "sort.monthly": "التكلفة الشهرية المقدّرة",
  "sort.input": "سعر الإدخال",
  "sort.output": "سعر الإخراج",
  "sort.context": "نافذة السياق",
  "sort.newest": "أحدث إصدار",
  "cap.reasoning": "الاستدلال",
  "cap.tools": "استدعاء الأدوات",
  "cap.vision": "الرؤية",
  "cap.structured": "إخراج منظّم",
  "cap.openWeights": "أوزان مفتوحة",
  "results.found": "عدد النماذج المطابقة: {count}",
  "results.source": "الأسعار موحّدة من الأسعار المنشورة. راجع وثائق المزوّد للتحقق.",
  "column.compare": "مقارنة",
  "column.model": "النموذج / المزوّد",
  "column.input": "الإدخال",
  "column.cached": "إدخال مخزّن مؤقتًا",
  "column.output": "الإخراج",
  "column.monthly": "التقدير الشهري",
  "column.context": "السياق",
  "column.capabilities": "استدلال  أدوات  رؤية",
  "column.actions": "الإجراءات",
  "action.officialDocs": "الوثائق الرسمية",
  "action.addCompare": "إضافة إلى المقارنة",
  "action.removeCompare": "إزالة من المقارنة",
  "action.addFavorite": "حفظ النموذج",
  "action.removeFavorite": "إزالة النموذج المحفوظ",
  "action.added": "تمت الإضافة",
  "context.suffix": "للسياق",
  "empty.title": "لا توجد نماذج مطابقة",
  "empty.description": "جرّب بحثًا آخر أو أزل عوامل تصفية القدرات.",
  "empty.clear": "مسح عوامل التصفية",
  "home.exploreKicker": "استكشف الكتالوج",
  "home.exploreTitle": "طرق أخرى لمقارنة نماذج الذكاء الاصطناعي",
  "home.providersTitle": "تصفّح حسب المزوّد",
  "home.providersBody": "قارن جميع النماذج المدعومة من OpenAI وAnthropic وGoogle وDeepSeek وAlibaba وغيرها.",
  "home.guideTitle": "اقرأ دليل الأسعار",
  "home.guideBody": "تعرّف على توزيع الرموز والتخزين المؤقت للموجّهات وشرائح السياق والعوامل التي تغيّر فاتورة API النهائية.",
  "home.open": "فتح",
  "providers.kicker": "دليل المزوّدين",
  "providers.title": "مزوّدو نماذج الذكاء الاصطناعي",
  "providers.intro": "تصفّح أسعار API الموحّدة وحدود السياق والقدرات لجميع المزوّدين الرئيسيين في كتالوج AgentBuck.",
  "providers.models": "عدد النماذج: {count}",
  "providers.starting": "أقل سعر للإدخال",
  "providers.view": "عرض المزوّد",
  "provider.kicker": "أسعار المزوّد",
  "provider.titleSuffix": "أسعار API",
  "provider.description": "قارن نماذج {name} البالغ عددها {count} حسب أسعار الإدخال والإخراج ونافذة السياق وقدرات الاستخدام في الإنتاج.",
  "provider.cheapest": "أقل تكلفة للإدخال",
  "provider.largestContext": "أكبر سياق",
  "provider.updated": "تحديث الكتالوج",
  "model.kicker": "تفاصيل أسعار النموذج",
  "model.title": "أسعار API لنموذج {name}",
  "model.descriptionFallback": "قارن أسعار رموز API وحدود السياق والقدرات والتكلفة الشهرية المقدّرة لهذا النموذج.",
  "model.input": "الإدخال / مليون رمز",
  "model.cache": "إدخال مخزّن / مليون رمز",
  "model.output": "الإخراج / مليون رمز",
  "model.context": "نافذة السياق",
  "model.maxOutput": "الحد الأقصى للإخراج",
  "model.released": "تاريخ الإصدار",
  "model.updated": "تحديث النموذج",
  "model.estimateTitle": "تقديرك الشهري",
  "model.estimateBody": "بناءً على {input} مليون رمز إدخال و{output} مليون رمز إخراج ونسبة إدخال مخزّن مؤقتًا تبلغ {cache}%.",
  "model.relatedTitle": "المزيد من نماذج {provider}",
  "compare.pageTitle": "مقارنة مشتركة لتكاليف نماذج الذكاء الاصطناعي",
  "compare.pageBody": "قارن أسعار الرموز ونوافذ السياق والقدرات والتكلفة الشهرية باستخدام الافتراضات المحفوظة في هذا الرابط.",
  "compare.emptyTitle": "لا توجد نماذج في هذه المقارنة",
  "compare.emptyBody": "اختر نموذجين أو ثلاثة من جدول الأسعار لإنشاء مقارنة قابلة للمشاركة.",
  "compare.start": "اختيار النماذج",
  "compare.usage": "عبء العمل المشترك",
  "notFound.title": "الصفحة غير موجودة",
  "notFound.body": "ربما نُقلت الصفحة أو لم يعد النموذج موجودًا في الكتالوج الحالي.",
  "guide.kicker": "دليل عملي للشراء",
  "guide.title": "قارن أسعار API للذكاء الاصطناعي وفق عبء عملك الفعلي",
  "guide.intro": "أقل سعر للإدخال لا يعني دائمًا أقل فاتورة إجمالية. يجمع AgentBuck تكاليف الموجّهات والموجّهات المخزّنة مؤقتًا والرموز المولّدة لتقييم GPT وClaude وGemini وDeepSeek وQwen وGrok وغيرها وفق عبء العمل نفسه.",
  "guide.inputTitle": "ابدأ بتوزيع الرموز لديك",
  "guide.inputBody": "تستهلك روبوتات المحادثة عادةً إدخالًا أكثر من الإخراج. أما وكلاء البرمجة وأنظمة الاستدلال فقد تولّد إخراجًا أكبر بكثير، مما يغيّر النموذج الأفضل من حيث التكلفة.",
  "guide.cacheTitle": "احتسب التخزين المؤقت للموجّهات",
  "guide.cacheBody": "قد تجعل موجّهات النظام المتكررة والسياقات المشتركة الطويلة سعر قراءة التخزين المؤقت عاملًا حاسمًا. حدّد نسبة واقعية للتخزين المؤقت قبل مقارنة الإجماليات الشهرية.",
  "guide.fitTitle": "تحقّق من القدرات والسياق",
  "guide.fitBody": "لا يكون السعر مفيدًا إلا إذا دعم النموذج متطلباتك لنافذة السياق والإدخال المرئي وعمق الاستدلال والإخراج المنظّم واستدعاء الأدوات.",
  "faq.kicker": "الأسئلة الشائعة",
  "faq.title": "أسئلة شائعة حول أسعار نماذج الذكاء الاصطناعي",
  "faq.q1": "كيف يقارن AgentBuck أسعار API لنماذج الذكاء الاصطناعي؟",
  "faq.a1": "يوحّد AgentBuck أسعار API القياسية في الوقت الفعلي بالدولار الأمريكي لكل مليون رمز، ثم يفصل تكاليف الإدخال والإدخال المخزّن مؤقتًا والإخراج. وتتوفر روابط وثائق المزوّدين للتحقق.",
  "faq.q2": "أي نموذج ذكاء اصطناعي يوفّر أرخص API؟",
  "faq.a2": "لا يوجد نموذج هو الأرخص في جميع الحالات. تعتمد الإجابة على نسبة الإدخال إلى الإخراج واستخدام التخزين المؤقت والقدرات المطلوبة. أدخل استخدامك الشهري أعلاه لترتيب النماذج وفق عبء عملك.",
  "faq.q3": "كيف تُحسب التكلفة الشهرية المقدّرة للنموذج اللغوي الكبير؟",
  "faq.a3": "يضرب التقدير أحجام الإدخال غير المخزّن والإدخال المخزّن مؤقتًا والإخراج في السعر المقابل لكل نموذج. ولا يشمل الضرائب أو خصومات الدُفعات أو الأسعار الإقليمية أو الرسوم الإضافية للسياق الطويل.",
  "faq.q4": "لماذا قد يظهر سعر نموذج بصفر دولار؟",
  "faq.a4": "ينشر بعض المزوّدين إتاحة مجانية أو ترويجية لنماذج محددة. قد تتغير الإتاحة والحدود، لذا تحقّق من وثائق المزوّد المرتبطة قبل الاستخدام في الإنتاج.",
  "faq.q5": "ما مدى حداثة بيانات الأسعار؟",
  "faq.a5": "يحدّث AgentBuck كتالوج الأسعار المنظّم كل ست ساعات. يعرض جدول النماذج أحدث تحديث للنماذج من المصدر، بينما تظل الفوترة الفعلية خاضعة لشروط المزوّد.",
  "method.title": "البيانات والمنهجية",
  "method.priceTitle": "أساس التسعير",
  "method.priceBody": "أسعار API القياسية في الوقت الفعلي بالدولار الأمريكي لكل مليون رمز. لا تشمل الضرائب أو أسعار الدُفعات أو الزيادات الإقليمية أو شرائح السياق الطويل.",
  "method.sourceTitle": "مصدر البيانات",
  "method.sourceBefore": "تُوحّد كتالوجات النماذج العامة وصفحات أسعار المزوّدين في مجموعة بيانات قابلة للمقارنة.",
  "method.sourceAfter": "يحدّثها AgentBuck كل ست ساعات ويوفّر روابط وثائق المزوّدين للتحقق.",
  "method.costTitle": "تقدير التكلفة",
  "method.costBody": "التكلفة الشهرية = الإدخال العادي + الإدخال المخزّن مؤقتًا + الإخراج. استخدمها لتخطيط الميزانية؛ لوحة تحكم المزوّد هي المرجع الرسمي للفوترة.",
  "footer.tagline": "اجعل لكل رمز قيمة.",
  "footer.updated": "تم تحديث البيانات في {date}",
  "compare.selected": "المحدّد: {count}/3",
  "compare.remove": "إزالة {name}",
  "compare.button": "مقارنة النماذج",
  "compare.kicker": "مقارنة النماذج",
  "compare.title": "الأسعار والقدرات جنبًا إلى جنب",
  "compare.close": "إغلاق",
  "compare.input": "الإدخال / مليون رمز",
  "compare.cache": "التخزين / مليون رمز",
  "compare.output": "الإخراج / مليون رمز",
  "compare.monthly": "التكلفة الشهرية المقدّرة",
  "compare.context": "السياق",
  "compare.capabilities": "استدلال / أدوات / رؤية",
  "compare.docs": "وثائق المزوّد",
  "compare.viewPrice": "عرض الأسعار",
  "nav.requestCalculator": "حاسبة تكلفة الطلبات",
  "home.calculatorTitle": "تقدير التكلفة حسب حجم الطلبات",
  "home.calculatorBody": "احسب الإنفاق الشهري استنادًا إلى الطلبات اليومية وعدد الرموز لكل طلب ومعدل إصابة التخزين المؤقت.",
  "home.compareDirectoryTitle": "تصفح مقارنات النماذج",
  "home.compareDirectoryBody": "ابدأ بمقارنة مختارة أو أنشئ مقارنتك الخاصة من جدول الأسعار.",
  "model.formulaTitle": "معادلة التكلفة",
  "model.formulaBody": "التكلفة الشهرية = (رموز الإدخال غير المخزّنة مؤقتًا × سعر الإدخال) + (رموز الإدخال المخزّنة مؤقتًا × سعر قراءة التخزين المؤقت) + (رموز الإخراج × سعر الإخراج)، لكل مليون رمز. بدون سعر قراءة تخزين مؤقت منشور، تُقدّر الرموز المخزّنة مؤقتًا بسعر الإدخال القياسي.",
  "model.exampleTitle": "مثال قابل لإعادة الإنتاج",
  "model.exampleBody": "مثال: {inputM} رمز إدخال ({cachePercent}% منها من التخزين المؤقت) و{outputM} رمز إخراج تكلف {total} وفق الأسعار المنشورة لهذا النموذج — {inputRate} للإدخال، {cacheRate} للإدخال المخزّن مؤقتًا، {outputRate} للإخراج لكل مليون رمز.",
  "model.calculatorCta": "تقدير التكلفة حسب حجم الطلبات اليومية",
  "model.comparisonsTitle": "يظهر ضمن هذه المقارنات المختارة",
};
